module.exports = __webpack_public_path__ + "static/rcc-knb61-study-design-mobile-35b6fb35ae49f38de6de614dfaffbf40.png";